import React from 'react';
import ShowerIcon from '@mui/icons-material/Shower';
import './TicketMedioSection.css';

const TicketMedioSection = () => {
  return (
    <section className="ticket-medio-section">
      <div 
        className="ticket-medio-background"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/cachorro-tosa.png)`,
        }}
      ></div>
      <div className="ticket-medio-content">
        <div className="ticket-medio-text">
          <h2 className="ticket-medio-title">
            Aumente seu ticket médio sem esforço.
          </h2>
          <p className="ticket-medio-description">
            Durante o atendimento, ofereça serviços adicionais — hidratação, corte de unhas — direto pelo app. Tudo é registrado, pago e repassado automaticamente +100% de receita por atendimento.
          </p>
          <h3 className="ticket-medio-subtitle">
            Confira os valores de repasse por plano
          </h3>
          
          <div className="ticket-medio-icons">
            <div className="ticket-medio-icon-card">
              <div className="ticket-icon-wrapper">
                <ShowerIcon className="ticket-icon" />
              </div>
              <div className="ticket-icon-text">
                <div className="ticket-icon-label">Banho Plano P</div>
                <div className="ticket-icon-value">R$ 45,00</div>
              </div>
            </div>

            <div className="ticket-medio-icon-card">
              <div className="ticket-icon-wrapper">
                <ShowerIcon className="ticket-icon" />
              </div>
              <div className="ticket-icon-text">
                <div className="ticket-icon-label">Banho Plano M</div>
                <div className="ticket-icon-value">R$ 67,50</div>
              </div>
            </div>

            <div className="ticket-medio-icon-card">
              <div className="ticket-icon-wrapper">
                <ShowerIcon className="ticket-icon" />
              </div>
              <div className="ticket-icon-text">
                <div className="ticket-icon-label">Banho Plano G</div>
                <div className="ticket-icon-value">R$ 90,00</div>
              </div>
            </div>
            
            <div className="ticket-medio-icon-card">
              <div className="ticket-icon-wrapper">
                <ShowerIcon className="ticket-icon" />
              </div>
              <div className="ticket-icon-text">
                <div className="ticket-icon-label">Banho Plano GG</div>
                <div className="ticket-icon-value">R$ 112,50</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TicketMedioSection;

